<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
// import { authHeader } from "../../../helpers/auth-header";
import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";
import InputGroup from "@/components/forms/input-group";
// import SelectGroup from "@/components/forms/select-group";
import { authHeader } from '@/helpers/fakebackend/auth-header';
import SaveButton from "@/components/buttons/save-button";
/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        InputGroup,
        // SelectGroup,
        SaveButton,
    },
    data() {
        return {
            id: '',
            title: `profile`,
            items: [
                {
                    text: "Profile"
                },
                {
                    text: 'Edit',
                    active: true,
                },
            ],
            name: '',
            email: '',
            pwd: '',
            cnfPwd: '',
            errors: {
            },
            status: '',
            userType: '',
            isChangedName: false,
        };
    },
    computed: {
    },
    async mounted() {
        const userData = localStorage.getItem('user');
        const userObject = JSON.parse(userData);
        const userType = userObject.user_type;
        this.userType = userType;
    },
    methods: {
        async chgPassword() {
            this.errors = {};
            let password = this.pwd;
            let confirm_password = this.cnfPwd;
            if (password == '') {
                this.errors.pwd = ['Field Cannot be Empty'];
            }
            if (confirm_password == '') {
                this.errors.cnfPwd = ['Field Cannot be Empty'];
            }
            if (!Object.hasOwn(this.errors,'cnfPwd') && !Object.hasOwn(this.errors, 'pwd')) {
                if (password === confirm_password) {
                    const staff_id = this.id;
                    const result = await axios.put(`${process.env.VUE_APP_APIURL}/admin/${staff_id}/password`, {"password": this.pwd, "password_confirmation": this.pwd }, {
                        headers: authHeader(),
                    });

                    if (result) {
                        if (result.data['code'] === 'success') {
                            //
                            this.$refs.messageModal.showModal('The password has been updated successfully');
                            this.pwd = '';
                            this.cnfPwd = '';
                        } else if (result.data['code'] === 'invalid_staff'){
                            this.$refs.messageModal.showModal('Invalid user token');
                        } else {
                            this.$refs.messageModal.showModal('Oops something went wrong');
                        }
                    }              
                } else {
                    this.errors ={"pwd": ['Password not match'], "cnfPwd": ['Password not match']};
                }
            }
        },
        async chgName() {
            this.errors = {};
            let name =  this.name;
            if (name != '') {
                const staff_id = this.id;
                const result = await axios.put(`${process.env.VUE_APP_APIURL}/admin-detail/${staff_id}`, {'name': this.name, 'email': this.email, 'status': this.id }, {
                    headers: authHeader(),
                });

                if (result) {
                    if (result.data['code'] === 'success') {
                        this.isChangedName = true;
                        let changeLocal = JSON.parse(localStorage.getItem("user"));
                        changeLocal.name = this.name;
                        changeLocal.email = this.email;
                        localStorage.setItem('user', JSON.stringify(changeLocal));
                        this.$refs.messageModal.showModal('Your record has been updated successfully');
                    } else if (result.data['code'] === 'invalid_staff'){
                            this.$refs.messageModal.showModal('Invalid user token');
                    } else {
                        this.$refs.messageModal.showModal('Something went wrong');
                    }
                }
            } else {
                this.errors= {"name": ['Name Cannot be Empty']};
            }
        },
        refreshPage: function(e) {
            if (e === 'Closed' && this.isChangedName)
                this.$router.go();
        }
    },
    async created() {
        const result = await axios.get(`${process.env.VUE_APP_APIURL}/admin/verify`, {
            headers: authHeader(),
        });
        if (result.data['code'] === 'success') {
            let {profile} = result.data.data;
            this.name = profile.name;
            this.email = profile.email;
            this.id = profile.id;
            this.status = profile.status;
        } else {
            alert('Something went wrong')
        }
    },
   
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal"/>
        <MessageModal ref="messageModal" @CloseBtn="refreshPage($event)"/>
        <div class="card card-form p-3">
            <div class="row no-gutters p-3">
                <div class="col-lg-4 card-body">
                    <p class="mb-0"><strong class="headings-color">Basic Information</strong></p>
                    <p class="text-muted">Edit your account details and settings.</p>
                </div>
                <div class="col-lg-8 card-form__body card-body">
                    <form class="form-horizontal" method="POST" id="profile-basic-form">
                        <div class="form-group">
                            <InputGroup type="text" id="name" displayName="Name" v-model="name" :error="errors.name" />
                        </div>
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input name="email" id="email" type="email" class="form-control" :value="email" disabled readonly>
                            <small class="invalid-feedback"></small>
                        </div>
                        <div class="text-left mt-5">
                            <SaveButton @click="chgName" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="card card-form p-3">
            <div class="row no-gutters p-3">
                <div class="col-lg-4 card-body">
                    <p class="mb-0"><strong class="headings-color">Password</strong></p>
                    <p class="text-muted">Change Your Password</p>
                </div>
                <div class="col-lg-8 card-form__body card-body">
                    <form class="form-horizontal" method="POST" id="profile-email-form">
                        <div class="form-group">
                            <InputGroup type="password" id="password" displayName="New Password" v-model="pwd" :error="errors.pwd" />
                        </div>
                        <div class="form-group">
                            <InputGroup type="password" id="confirm_password" displayName="Confirm Password" v-model="cnfPwd" :error="errors.cnfPwd" />
                        </div>
                        <div class="text-left mt-5">
                            <SaveButton @click="chgPassword"/>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </Layout>
</template>